import "./view_community.css";
import Layout from "../../../layout";
import showFile from "../../../helpers/show_file";
import { FiMessageCircle } from "react-icons/fi";
import { FaHeart, FaRegHeart } from "react-icons/fa6";
import { FaRegTrashAlt } from "react-icons/fa";
import Button from "antd/lib/button";
import { dateHelper } from "../../../helpers/date_helper";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Avatar from "antd/lib/avatar";
import useCommunity from "../../../hooks/use_community";
import { useSelector } from "react-redux";
import LoadingPrimary from "../../../assets/animations/loading_primary.svg";
import { useEffect, useRef } from "react";
import Modal from "antd/lib/modal";
import { IoClose, IoCloseCircleOutline } from "react-icons/io5";
import { LuImage, LuMessageCirclePlus } from "react-icons/lu";
import TextArea from "antd/lib/input/TextArea";

const ViewCommunity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    // entity methods
    getPostById,
    likePostView,
    getPostReplies,
    likeReply,
    deleteReply,
    // controller methods
    createReplyController,
    // entity states
    viewPostData,
    postRepliesData,
    // controller states
    viewPostLikedByMe,
    viewPostLikes,
    deletePostModal,
    setDeletePostModal,
    paginates,
    deleteReplyModal,
    setDeleteReplyModal,
    selectedReply,
    setSelectedReply,
    newPostModal,
    setNewPostModal,
    // loadings
    loadings,
  } = useCommunity();

  let uploadFileRef = useRef(null);

  const postId = location.pathname.split("/")[2];

  const userProfile = useSelector((state) => state.app.userProfile);

  const handleUploadFile = (e) => {
    let array = [...createReplyController.values.files];
    let file = e.target.files[0];
    if (file) {
      array.push({
        file: file,
        url: URL.createObjectURL(file),
      });
      createReplyController.setFieldValue("files", array);
    }
    e.target.value = null;
  };

  useEffect(() => {
    if (userProfile && postId) {
      getPostById(postId);
    }
  }, [userProfile, postId]);

  useEffect(() => {
    if (viewPostData) {
      getPostReplies(viewPostData?.course?.id, viewPostData?.id, 1);
    }
  }, [viewPostData]);

  return (
    <Layout>
      <div className={"view_community"}>
        {loadings.getPostById ? (
          <div
            className={"post_card"}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "24px 0",
            }}
          >
            <img
              src={LoadingPrimary}
              alt="Loading"
              style={{ width: 64, height: 64 }}
            />
          </div>
        ) : (
          <div className={"post_card"}>
            <div className={"view_community_title"}>
              <div>
                {viewPostData?.author?.avatar ? (
                  <img
                    src={showFile(viewPostData?.author?.avatar)}
                    alt="ellipse"
                  />
                ) : (
                  <div>
                    {viewPostData?.author?.fullname?.slice(0, 1)?.toUpperCase()}
                  </div>
                )}
              </div>
              <div>
                <h1>
                  {viewPostData?.author?.fullname}{" "}
                  <span>{dateHelper(viewPostData?.createTime)}</span>
                </h1>
                <div className={"avatar"}>{viewPostData?.text}</div>
              </div>
              <div>
                <Button
                  onClick={() => {
                    likePostView();
                  }}
                >
                  {viewPostLikedByMe ? (
                    <FaHeart style={{ color: "var(--red)" }} />
                  ) : (
                    <FaRegHeart />
                  )}
                  {viewPostLikes}
                </Button>
                <Button>
                  <FiMessageCircle />
                  {viewPostData?.replyCount}
                </Button>
                {userProfile?.id == viewPostData?.author?.id ? (
                  <Button
                    onClick={() => {
                      setDeletePostModal(true);
                    }}
                  >
                    <FaRegTrashAlt />
                  </Button>
                ) : null}
              </div>
            </div>
            {viewPostData?.images?.length > 0 ? (
              <div
                className={`${"gallery_container"} ${
                  viewPostData?.images.length === 1
                    ? "grid_1"
                    : viewPostData?.images?.length === 2
                      ? "grid_2"
                      : viewPostData?.images?.length === 3
                        ? "grid_3"
                        : "grid_4plus"
                }`}
              >
                {viewPostData?.images?.map((image, imageIndex) => (
                  <Link
                    to={showFile(image?.name)}
                    target="_blank"
                    key={imageIndex}
                  >
                    <img src={showFile(image?.name)} alt="review" />
                  </Link>
                ))}
              </div>
            ) : null}
          </div>
        )}
        {/* replies */}
        {!loadings.getPostById && postRepliesData?.length > 0 ? (
          <div className={"comments_container"}>
            {postRepliesData?.map((post, index) => (
              <div key={index} className={"comments_item"}>
                <div className={"comments_item_left"}>
                  <div>
                    <div>
                      {post?.author?.avatar ? (
                        <img
                          src={showFile(post?.author?.avatar)}
                          alt={post?.author?.fullname}
                        />
                      ) : (
                        <div>
                          {post?.author?.fullname?.slice(0, 1)?.toUpperCase()}
                        </div>
                      )}
                    </div>
                    {post?.replies?.length > 0 ? (
                      <div className={"line6"}></div>
                    ) : null}
                    {post?.replies?.length > 0 ? (
                      <div className={"avatar"}>
                        <Avatar.Group
                          maxCount={5}
                          maxStyle={{
                            color: "#fff",
                            backgroundColor: "#1677ff",
                          }}
                        >
                          {post?.replies?.map((reply, replyIndex) => (
                            <Avatar
                              key={replyIndex}
                              src={
                                reply?.author?.avatar ? (
                                  <img
                                    src={showFile(reply?.author?.avatar)}
                                    alt="avatar"
                                  />
                                ) : (
                                  <div className={"reply_avatar"}>
                                    {reply?.author?.fullname
                                      ?.slice(0, 1)
                                      ?.toUpperCase()}
                                  </div>
                                )
                              }
                            />
                          ))}
                        </Avatar.Group>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className={"comments_item_right"}>
                  <div className={"comments_item_right1"}>
                    <h3>{post?.author?.fullname}</h3>
                    <div>
                      <span> {dateHelper(post?.createTime)}</span>
                      {post?.author?.id == userProfile?.id ? (
                        <Button
                          onClick={() => {
                            setDeleteReplyModal(true);
                            setSelectedReply(post);
                          }}
                        >
                          <FaRegTrashAlt />
                        </Button>
                      ) : null}
                    </div>
                  </div>
                  <p>{post?.text}</p>
                  <div className={"comments_item_right3"}>
                    <Button
                      onClick={() => {
                        likeReply(post);
                      }}
                    >
                      {post?.likedByMe ? (
                        <FaHeart style={{ color: "var(--red)" }} />
                      ) : (
                        <FaRegHeart />
                      )}
                      {post?.likeCount}
                    </Button>
                    <Button
                      onClick={() => {
                        navigate(`/community/${post?.id}`);
                      }}
                    >
                      <FiMessageCircle />
                      {post?.replyCount}
                    </Button>
                  </div>
                  {post?.images?.length > 0 ? (
                    <div
                      className={`${"gallery_container"} ${
                        post?.images.length === 1
                          ? "grid_1"
                          : post?.images?.length === 2
                            ? "grid_2"
                            : post?.images?.length === 3
                              ? "grid_3"
                              : "grid_4plus"
                      }`}
                    >
                      {post?.images?.map((image, imageIndex) => (
                        <Link
                          to={showFile(image?.name)}
                          target="_blank"
                          key={imageIndex}
                        >
                          <img src={showFile(image?.name)} alt="review" />
                        </Link>
                      ))}
                    </div>
                  ) : null}
                </div>
                <div
                  onClick={() => {
                    navigate(`/community/${post?.id}`);
                  }}
                ></div>
              </div>
            ))}
          </div>
        ) : null}
        {paginates.has_more ? (
          <div className={"pagination"}>
            {loadings.getPostRepliesPaginates ? (
              <img
                src={LoadingPrimary}
                width={20}
                height={20}
                alt="Loading..."
              />
            ) : (
              <div
                onClick={() => {
                  getPostReplies(
                    viewPostData?.course?.id,
                    viewPostData?.id,
                    paginates.current + 1,
                  );
                }}
              >
                Load more replies
              </div>
            )}
          </div>
        ) : null}
        {loadings.getPostReplies ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={LoadingPrimary}
              alt="Loading..."
              style={{ width: 64, height: 64 }}
            />
          </div>
        ) : null}
        {/* new post button */}
        <div className={"share_btn"}>
          <Button
            onClick={() => {
              setNewPostModal(true);
              createReplyController.setFieldValue(
                "courseId",
                viewPostData?.course?.id,
              );
              createReplyController.setFieldValue("parentId", viewPostData?.id);
              createReplyController.setFieldValue("text", "");
              createReplyController.setFieldValue("files", []);
            }}
          >
            <LuMessageCirclePlus />
            <span>Reply To Post</span>
          </Button>
        </div>
      </div>
      {/* new post modal */}
      <Modal
        open={newPostModal}
        onCancel={() => {
          setNewPostModal(false);
        }}
        footer={null}
        className="sharetModal"
        closeIcon={null}
      >
        <form
          onSubmit={createReplyController.handleSubmit}
          className="share_modal_container"
        >
          <div className="share_modal_title">
            <Button
              onClick={() => {
                setNewPostModal(false);
              }}
              disabled={loadings.createPost}
            >
              <IoClose />
            </Button>
            <h3>Reply to post</h3>
          </div>
          <h3>Share your thoughts</h3>
          <TextArea
            name="text"
            id="text"
            value={createReplyController.values.text}
            onChange={createReplyController.handleChange}
            disabled={loadings.createPost}
            status={
              createReplyController.touched.text &&
              createReplyController.errors.text
                ? "error"
                : ""
            }
            placeholder="Write your post or question here"
            rows={7}
          />
          <div className="add_btn_share_modal">
            <Button
              htmlType="button"
              disabled={loadings.createPost}
              onClick={() => {
                uploadFileRef.current?.click();
              }}
            >
              <span>
                <LuImage /> Add media
              </span>
            </Button>
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleUploadFile}
              ref={uploadFileRef}
              accept="image/*"
            />
          </div>
          {createReplyController.values.files?.length > 0 ? (
            <div className="create_post_media">
              {createReplyController.values.files?.map((item, index) => (
                <div key={index}>
                  <img src={item.url} alt={"Uploaded file"} />
                  <div>
                    <FaRegTrashAlt
                      onClick={() => {
                        if (!loadings.createPost) {
                          let array = [...createReplyController.values.files];
                          array = array.filter((o, ind) => ind != index);
                          createReplyController.setFieldValue("files", array);
                        }
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {/* post_btn */}
          <div className="post_btn">
            <Button loading={loadings.createPost} htmlType="submit">
              Post
            </Button>
            <Button
              disabled={loadings.createPost}
              onClick={() => {
                setNewPostModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete reply modal */}
      <Modal
        open={deleteReplyModal}
        onCancel={() => {
          setDeleteReplyModal(false);
        }}
        footer={null}
        className="deleteCommentModal"
        closeIcon={null}
      >
        <div className="delete_comment_modal_container">
          <div className="delete_comment_modal_title">
            <Button
              onClick={() => {
                setDeleteReplyModal(false);
              }}
            >
              <IoClose />
            </Button>
            <IoCloseCircleOutline />
          </div>
          <div>
            <h3>Are you sure you want to delete this reply?</h3>
          </div>
          <div className="delete_comment_modal_btn">
            <Button
              onClick={() => {
                deleteReply(selectedReply?.id);
              }}
              loading={loadings.deleteReply}
            >
              Yes, Delete
            </Button>
            <Button
              onClick={() => {
                setDeleteReplyModal(false);
              }}
              disabled={loadings.deleteReply}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default ViewCommunity;
